
// Import other functionality (you can keep these if needed)
import setupMobileMenu from "./menus/mobile-menu.js";
// import Swiper from 'swiper';
// import 'swiper/swiper-bundle.min.css';
import setupHeaderAnimations from "./animations/animate-header.js";
import { setupScrollSmoother } from "./animations/scroll-smoother.js";
import { fadeInOnScroll } from './animations/fadeInOnScroll.js';

// Initialize features
document.addEventListener("DOMContentLoaded", () => {
  setupMobileMenu(); // Initialize mobile menu
  setupHeaderAnimations(); // Initialize header animations
  setupScrollSmoother(); // Initialize ScrollSmoother
  // setupCafeMenu(); // Initialize cafe menu functionality
});
